import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Typography from '../../overrides/Typography';
import clsx from 'clsx';
import {
  SEARCH_SELECTOR_ARIA_LABEL,
  SEARCH_SELECTOR_DATE_DEFAULT,
  SEARCH_SELECTOR_GUESTS_DEFAULT,
  SEARCH_SELECTOR_TIME_DEFAULT,
} from '../../../assets/copy';

const useStyles = makeStyles((theme) => ({
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.625, 1.875),
    borderRadius: theme.spacing(5),
    border: `1px solid ${theme.palette.secondary[65]}`,
    boxSizing: 'border-box',
    backgroundColor: theme.palette.spoon.white[100],
    cursor: 'pointer',
  },
  pillActive: {
    border: `1px solid ${theme.palette.spoon.blue[40]}`,
    backgroundColor: theme.palette.spoon.blue[40],
  },
  textActive: {
    color: theme.palette.spoon.white[100],
  },
  separator: {
    width: 1,
    height: theme.spacing(2.5),
    margin: theme.spacing(0, 1.5),
    backgroundColor: theme.palette.secondary[65],
  },
  separatorActive: {
    backgroundColor: theme.palette.spoon.white[100],
  },
}));

const SearchSelectorPill = ({ isActive, guestNumber, date, time, onClick }) => {
  const classes = useStyles();
  const pillClasses = clsx(classes.pill, { [classes.pillActive]: isActive });
  const textClasses = clsx({ [classes.textActive]: isActive });
  const separatorClasses = clsx(classes.separator, {
    [classes.separatorActive]: isActive,
  });

  return (
    <Box
      className={pillClasses}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onClick(event);
        }
      }}
      role="button"
      aria-label={SEARCH_SELECTOR_ARIA_LABEL}>
      <Typography variant="small4Semibold" className={textClasses}>
        {isActive ? guestNumber : SEARCH_SELECTOR_GUESTS_DEFAULT}
      </Typography>
      <div className={separatorClasses} />
      <Typography variant="small4Semibold" className={textClasses}>
        {isActive ? date : SEARCH_SELECTOR_DATE_DEFAULT}
      </Typography>
      <div className={separatorClasses} />
      <Typography variant="small4Semibold" className={textClasses}>
        {isActive ? time : SEARCH_SELECTOR_TIME_DEFAULT}
      </Typography>
    </Box>
  );
};

export default SearchSelectorPill;
